import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=884089f2&"
import script from "./supplierList.vue?vue&type=script&lang=js&"
export * from "./supplierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports